import dispatcher from "../Dispatcher/Dispatcher";
import config from "./../Config/Config";
import httpRequest from "./../HttpRequests/HttpRequest";
import EmailConstants from "../Constants/EmailNotificationConstants";

class EmailNotification_Action {
  getEmailDistributionGroup() {
    httpRequest(
      config.webServiceURL + "/EmailSchedule/GetEmailDistributionGroups",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: EmailConstants.GET_EMAIL_DISTRIBUTION_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: EmailConstants.GET_EMAIL_DISTRIBUTION_GROUP_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  saveOrupdateEmailDistributionGroup(datdObj) {
    httpRequest(
      config.webServiceURL +
        "/EmailSchedule/SaveOrUpdateEmailDistributionGroup",
      "POST",
      JSON.stringify({
        ...datdObj,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: EmailConstants.ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: EmailConstants.ADD_OR_UPDATE_EMAIL_DISTRIBUTION_GROUP_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getEquipmentFilter(anlagegruppeid) {
    httpRequest(
      config.webServiceURL +
        "/EmailSchedule/GetEmailEquipmentFilters/" +
        anlagegruppeid,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: EmailConstants.GET_EQIPMENT_FILTER_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: EmailConstants.GET_EQIPMENT_FILTER_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  saveOrupdateEmailSchedule(datdObj) {
    httpRequest(
      config.webServiceURL + "/EmailSchedule/SaveOrUpdateEmailSchedule",
      "POST",
      JSON.stringify({
        ...datdObj,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: EmailConstants.SAVE_OR_UPDATE_EMAIL_SCHEDULE_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: EmailConstants.SAVE_OR_UPDATE_EMAIL_SCHEDULE_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  getScheduleEmail() {
    httpRequest(
      config.webServiceURL + "/EmailSchedule/GetScheduledEmails",
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: EmailConstants.GET_SCHEDULE_EMAIL_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: EmailConstants.GET_SCHEDULE_EMAIL_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  replaceEmail(datdObj) {
    httpRequest(
      config.webServiceURL + "/EmailSchedule/ReplaceEmail",
      "POST",
      JSON.stringify({
        NewEmail: datdObj.NewEmail,
        OldEmail: datdObj.OldEmail,
      }),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: EmailConstants.REPLACE_EMAIL_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: EmailConstants.REPLACE_EMAIL_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  deleteScheduleEmail(ID) {
    httpRequest(
      config.webServiceURL + "/EmailSchedule/DeleteEmailSchedule/",
      "DELETE",
      JSON.stringify([...ID]),
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: EmailConstants.DELETE_SCHEDULE_EMAIL_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: EmailConstants.DELETE_SCHEDULE_EMAIL_FAILURE,
            result: message,
          });
        }
      }
    );
  }

  // getScheduleEmailById(id) {
  //   httpRequest(
  //     config.webServiceURL + "/EmailSchedule/GetScheduledEmail/" + id,
  //     "GET",
  //     null,
  //     (res, message) => {
  //       if (res !== "Error") {
  //         dispatcher.dispatch({
  //           type: EmailConstants.GET_SCHEDULE_EMAIL_BYID_SUCCESS,
  //           result: res,
  //         });
  //       } else {
  //         dispatcher.dispatch({
  //           type: EmailConstants.GET_SCHEDULE_EMAIL_BYID_FAILURE,
  //           result: message,
  //         });
  //       }
  //     }
  //   );
  // }
  getScheduleEmailAttachment(schedule, distributionGroupId) {
    httpRequest(
      config.webServiceURL +
        "/EmailSchedule/GetScheduledEmailAttachment/" +
        schedule +
        "/" +
        distributionGroupId,
      "GET",
      null,
      (res, message) => {
        if (res !== "Error") {
          dispatcher.dispatch({
            type: EmailConstants.GET_SCHEDULE_EMAIL_ATTACHMENT_SUCCESS,
            result: res,
          });
        } else {
          dispatcher.dispatch({
            type: EmailConstants.GET_SCHEDULE_EMAIL_ATTACHMENT_FAILURE,
            result: message,
          });
        }
      }
    );
  }
}

export default new EmailNotification_Action();
